// extracted by mini-css-extract-plugin
module.exports = {"container":"ElectionTracker_container__2kzjp","image":"ElectionTracker_image__3-yDb","circle":"ElectionTracker_circle__37-Fn"};